import { home } from '@project/api/home/v1'
import { page as referToUsPage } from '@project/api/refer-to-us/v1'


export default {
  async home() {
    return await home()
  },
  async referToUs() {
    return await referToUsPage()
  }
}

